import React from 'react';
import { CriterionType } from '../../../models/assessment.types';

interface CriterionTypeIconProps {
  criterionType: CriterionType;
}

export const CriterionTypeIcon: React.FC<CriterionTypeIconProps> = ({ criterionType }) => {
  const getCriterionColor = () => {
    switch (criterionType) {
      case CriterionType.leadingCriterion:
        return '#347F42';
      case CriterionType.dependentCriterion:
        return '#9747FF';
    }
  };

  const getCriterionLabel = () => {
    switch (criterionType) {
      case CriterionType.leadingCriterion:
        return 'W';
      case CriterionType.dependentCriterion:
        return 'Z';
    }
  };

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 11C16 13.7614 13.7614 16 11 16L1.90735e-06 16L3.88377e-07 -6.11161e-07L11 -1.50229e-06C13.7614 -1.726e-06 16 2.23857 16 5L16 11Z"
        fill={getCriterionColor()}
      />
      <text x={criterionType === CriterionType.leadingCriterion ? "3" : "4"} y="12" fill={'#FFFFFF'} fontFamily="Roboto" fontWeight="500" fontSize="10px">
        {getCriterionLabel()}
      </text>
    </svg>
  );
};
